module.exports = __webpack_public_path__ + "static/media/introKan.85c13f76.jpg";